import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML that the API builds with record data inside it, before it reaches
 * v-html: timeline entries (`<p>Cadastro <strong>{nome}</strong></p>`) and e-mail bodies
 * (the template with the cadastro's name and the charge's description filled in).
 *
 * The API puts those fields in without escaping, and a cadastro's name can be edited from
 * the client area by someone outside the tenant, so a name like `<img src=x onerror=...>`
 * would run in the browser of whoever opens the timeline or the e-mail (and could read
 * the token in localStorage). Escaping here would print the markup, so the markup is
 * kept and only what can run is dropped: scripts, event handlers, javascript: URLs,
 * iframes. The proper fix is escaping in the API; this holds until then, and after.
 *
 * `target` is kept so links that open in a new tab still do.
 */
export function sanitizarHtml(html) {
  if (html === null || html === undefined) return '';
  return DOMPurify.sanitize(String(html), { ADD_ATTR: ['target'] });
}

export default sanitizarHtml;
